import { faDownload } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Grid, LinearProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from "@mui/material";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ServiceContext } from "../../Contexts/ServiceContext/ServiceContext";
import { useLoading } from "../../Hooks/useLoading";
import { useTableCoreFunctions } from "../../Hooks/useTableCoreFunctions";
import { IDocumentRecord } from "../../Interfaces/IDocumentRecord";
import { GLOBALS } from "../../Models/Globals";
import { NoRecordsMessage } from "../NoRecordsMessage/NoRecordsMessage";
import { HeaderTableCell } from "../Styled/HeaderTableCell";
import { YearFilter } from "../YearFilter/YearFilter";
import { ZoneFilter } from "../ZoneFilter/ZoneFilter";
import 'moment/locale/es';



export const ZoneDocumentRender = () => {

    const { SrvContext } = useContext(ServiceContext);
    const { t, i18n } = useTranslation();
    const [isLoading, SetIsLoading] = useLoading();

    const [currentDocs, setCurrentDocs] = useState<IDocumentRecord[]>([]);
    const [filteredDocs, setFilteredDocs] = useState<IDocumentRecord[]>([]);
    const [currentYearFilter, setCurrentYearFilter] = useState<number>(moment().year());
    const [zoneFilter, setZoneFilter] = useState<string>(`${GLOBALS.NO_SELECTED_OPTION}`);

    const [
        page,
        rowsPerPage,
        handleChangePage,
        renderActivoIcon,
        handleChangeRowsPerPage,
        formatFecha
    ] = useTableCoreFunctions();

    const Initialize = async () => {

        const docs = SrvContext.WindowData.sccoDocsRender.DocsToRender;
        setCurrentDocs(docs);
        setFilteredDocs(docs);
        await i18n.changeLanguage(SrvContext.WindowData.sccoDocsRender.idiomaCode);
        moment().locale(SrvContext.WindowData.sccoDocsRender.idiomaCode == 'esp' ? 'es' : 'en');
        SetIsLoading(false);

    };


    const onYearChanged = (selectedValue: number) => {

        setCurrentYearFilter(selectedValue);
        if (selectedValue == GLOBALS.NO_SELECTED_OPTION) {

            setFilteredDocs(currentDocs);

        } else {

            setFilteredDocs(currentDocs.filter((doc, index) => {
                if (zoneFilter == `${GLOBALS.NO_SELECTED_OPTION}`) {
                    return doc.year == selectedValue;
                } else {
                    if (selectedValue == GLOBALS.NO_SELECTED_OPTION) {
                        return doc.nombre_zona == zoneFilter;
                    } else {
                        return doc.year == selectedValue && doc.nombre_zona == zoneFilter;
                    }
                }
            }));

        }

    };

    const onZoneChange = (selectedZone: string) => {

        setZoneFilter(selectedZone);

        if (selectedZone == `${GLOBALS.NO_SELECTED_OPTION}` && currentYearFilter == GLOBALS.NO_SELECTED_OPTION) {

            setFilteredDocs(currentDocs);
            return;

        }


        setFilteredDocs(currentDocs.filter((doc, index) => {
            if (currentYearFilter == GLOBALS.NO_SELECTED_OPTION) {
                return doc.nombre_zona == selectedZone;
            } else {
                if (selectedZone == `${GLOBALS.NO_SELECTED_OPTION}`) {
                    return doc.year == currentYearFilter;
                } else {
                    return doc.year == currentYearFilter && doc.nombre_zona == selectedZone;
                }
            }
        }));


    };


    useEffect(() => {

        Initialize();

    }, []);

    return (
        <Grid container spacing={3} xs={12}>
            {
                isLoading ? (
                    <LinearProgress />
                ) : (
                    currentDocs.length == 0 ? (
                        <NoRecordsMessage />
                    ) : (
                        <Grid item container xs={12} spacing={3}>
                            <Grid item container xs={12} spacing={3}>
                                <Grid item xs={12} md={4}>
                                    <YearFilter
                                        OnSelectionChange={onYearChanged}
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <ZoneFilter
                                        OnSelectionChange={onZoneChange}
                                    />
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <TableContainer component={Paper}>
                                    <Table sx={{ minWidth: 700 }}>
                                        <TableHead>
                                            <TableRow>
                                                <HeaderTableCell align="center"></HeaderTableCell>
                                                <HeaderTableCell align="center">{t('label-year')}</HeaderTableCell>
                                                <HeaderTableCell align="center">{t('label-publish-date')}</HeaderTableCell>
                                                <HeaderTableCell align="center">{t('label-inspection-date')}</HeaderTableCell>
                                                <HeaderTableCell align="center">{t('label-month')}</HeaderTableCell>
                                                <HeaderTableCell align="center">{t('label-region')}</HeaderTableCell>
                                                <HeaderTableCell align="center">{t('label-zone')}</HeaderTableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                filteredDocs.length == 0 ? (
                                                    <TableRow>
                                                        <TableCell colSpan={6}>
                                                            {t('label-no-records')}
                                                        </TableCell>
                                                    </TableRow>
                                                ) : (
                                                    <>
                                                        {
                                                            filteredDocs.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                .map((doc, index) => (
                                                                    <TableRow hover key={`table-row-${index}`}>
                                                                        <TableCell align="center">
                                                                            <Button href={doc.url} target="_blank" variant="contained">
                                                                                <Typography variant="body1">
                                                                                    <FontAwesomeIcon icon={faDownload} />
                                                                                </Typography>
                                                                            </Button>
                                                                        </TableCell>
                                                                        <TableCell align="center">{doc.year}</TableCell>
                                                                        <TableCell align="center">{moment(doc.fecha_publicacion).format(GLOBALS.DATE_FORMAT)}</TableCell>
                                                                        <TableCell align="center">{doc.fecha_inspeccion ? moment(doc.fecha_inspeccion).format(GLOBALS.DATE_FORMAT) : ""}</TableCell>
                                                                        <TableCell align="center">{doc.mes_reporte}</TableCell>
                                                                        {/* <TableCell align="center">{moment(doc.fecha_publicacion).format("MMMM")}</TableCell> */}
                                                                        <TableCell align="center">{doc.nombre_region}</TableCell>
                                                                        <TableCell align="center">{doc.nombre_zona}</TableCell>
                                                                    </TableRow>
                                                                ))
                                                        }
                                                    </>
                                                )
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <TablePagination
                                    rowsPerPageOptions={[25, 50, 75, 100]}
                                    component="div"
                                    count={filteredDocs.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                            </Grid>
                        </Grid>
                    )
                )
            }
        </Grid>
    );


};